export const MonobankTipsTranslation = {
    en: `
Each jar can only be linked to one site.

If you use at least one jar in another service, donation information will be sent only to the last service where this or another jar was linked.

Unfortunately, this is a limitation of Monobank.
    `,
    uk: `
Кожну банку можна привʼязати лише до одного сайту.

Якщо ви використовуєте хоча б одну банку в інших сервісах, інформація про донати надходитиме лише до останнього сервісу, до якого було привʼязано цю або іншу банку.

На жаль, це обмеження Monobank.
    `
}
